var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full_loader_bg"},[_c('div',{staticClass:"full_loader_container"},[_c('div',{staticClass:"full_loader_circle"}),_c('img',{staticClass:"full_loader_logo",attrs:{"src":"/apaly_circle_logo.png"}})])])
}]

export { render, staticRenderFns }